webpackJsonp([170264817138936],{

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArchiveContent = function ArchiveContent(_ref) {
	    var data = _ref.data,
	        archiveType = _ref.archiveType;
	    return _react2.default.createElement(
	        'div',
	        null,
	        data.featured_media != 'false' && _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' + archiveType + '/' + data.slug },
	            _react2.default.createElement(
	                'div',
	                { className: 'featured-image' },
	                _react2.default.createElement('img', { src: data.featured_media })
	            )
	        ),
	        data.featured_media == 'false' && _react2.default.createElement('div', { className: 'featured-image' }),
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' + archiveType + '/' + data.slug },
	            _react2.default.createElement('h2', { className: 'h2', dangerouslySetInnerHTML: { __html: data.title } })
	        ),
	        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: data.excerpt } }),
	        _react2.default.createElement(
	            'p',
	            { className: 'date' },
	            data.date
	        ),
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { style: { marginTop: '10px', display: 'inline-block', cursor: 'pointer' }, className: 'hoverlink', to: '/' + archiveType + '/' + data.slug },
	            'Read More'
	        )
	    );
	};
	
	exports.default = ArchiveContent;
	module.exports = exports['default'];

/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pressQuery = exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Hero = __webpack_require__(9);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Signup = __webpack_require__(64);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	var _Apply = __webpack_require__(20);
	
	var _Apply2 = _interopRequireDefault(_Apply);
	
	var _Row = __webpack_require__(3);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Column = __webpack_require__(4);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _ArchiveContent = __webpack_require__(334);
	
	var _ArchiveContent2 = _interopRequireDefault(_ArchiveContent);
	
	var _reactTransitionGroup = __webpack_require__(112);
	
	var _gsap = __webpack_require__(29);
	
	var _Pagination = __webpack_require__(155);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PRESS_PER_PAGE = 6;
	
	var press = function (_Component) {
	    _inherits(press, _Component);
	
	    function press(props) {
	        _classCallCheck(this, press);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            pages: props.data.press.edges,
	            currentPage: 1,
	            activePress: props.data.press.edges
	        };
	        return _this;
	    }
	
	    press.prototype.componentDidMount = function componentDidMount() {
	        this.params = {};
	        if (window.location.search) {
	            this.params = this.getUrlParams(window.location.search);
	        }
	        var totalPages = Math.ceil(this.state.pages.length / PRESS_PER_PAGE);
	        var pageNumArray = [];
	        for (var i = 1; i <= totalPages; i++) {
	            pageNumArray.push(i);
	        }
	
	        this.setState({ pages: pageNumArray });
	
	        this.row.refs.thisRow.style.position = 'relative';
	    };
	
	    press.prototype.handlePageChange = function handlePageChange(index) {
	        // console.log('index == ', index)
	        if (index > 0 && index <= this.state.pages.length) {
	            this.params.page = index;
	            this.lastPage = this.state.currentPage;
	            this.setUrlParameters();
	            var pageNumberOffset = this.state.pageNumberOffset;
	
	            this.setState({ currentPage: index, pageNumberOffset: pageNumberOffset });
	        }
	    };
	
	    press.prototype.handleCardEnter = function handleCardEnter(node) {
	        var tl = new _gsap.TimelineMax();
	        tl.set(node, { css: { position: 'absolute', top: 0 } });
	        if (this.lastPage && this.lastPage < this.state.currentPage) {
	            // slide in left
	            tl.fromTo(node, .15, { x: '100%' }, { x: '-=100%' }, .15);
	            tl.set(node, { css: { position: 'relative' } });
	        } else {
	            // slide in left
	            tl.fromTo(node, .15, { x: '-100%' }, { x: '+=100%' }, .15);
	            tl.set(node, { css: { position: 'relative' } });
	        }
	    };
	
	    press.prototype.handleCardExit = function handleCardExit(node) {
	        if (this.lastPage && this.lastPage < this.state.currentPage) {
	            TweenMax.fromTo(node, .15, { x: 0 }, { x: '-=100%' });
	        } else {
	            TweenMax.fromTo(node, .15, { x: 0 }, { x: '+=100%' });
	        }
	    };
	
	    press.prototype.getUrlParams = function getUrlParams(search) {
	        var hashes = search.slice(search.indexOf('?') + 1).split('&');
	        return hashes.reduce(function (params, hash) {
	            var _extends2;
	
	            var _hash$split = hash.split('='),
	                key = _hash$split[0],
	                val = _hash$split[1];
	
	            return _extends(params, (_extends2 = {}, _extends2[key] = decodeURIComponent(val), _extends2));
	        }, {});
	    };
	
	    press.prototype.setUrlParameters = function setUrlParameters() {
	        var _this2 = this;
	
	        var queryString = Object.keys(this.params).map(function (key) {
	            return key + '=' + _this2.params[key];
	        }).join('&');
	        var newurl = window.location.pathname + '?' + queryString;
	        window.history.replaceState({ path: newurl }, '', newurl);
	    };
	
	    press.prototype.getPressByPage = function getPressByPage() {
	        var _state = this.state,
	            currentPage = _state.currentPage,
	            activePress = _state.activePress;
	
	        var startIndex = (currentPage - 1) * PRESS_PER_PAGE;
	        return activePress.slice(startIndex, startIndex + PRESS_PER_PAGE);
	    };
	
	    press.prototype.render = function render() {
	        var _this3 = this;
	
	        var press = this.props.data.press;
	        var _state2 = this.state,
	            currentPage = _state2.currentPage,
	            pages = _state2.pages;
	
	        var pagedPress = this.getPressByPage();
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'page-archive' },
	            _react2.default.createElement(_reactHelmet2.default, { title: 'News & Press | Global Citizen Year' }),
	            _react2.default.createElement(_Hero2.default, { title: 'News & Press' }),
	            _react2.default.createElement(
	                _Row2.default,
	                { className: 'capper', style: { paddingBottom: '30px' } },
	                pages.length > 1 && _react2.default.createElement(_Pagination2.default, { pages: pages, currentPage: currentPage, handlePageChange: function handlePageChange(page) {
	                        return _this3.handlePageChange(page);
	                    } })
	            ),
	            _react2.default.createElement(
	                _Row2.default,
	                { className: 'cards-container capper no-top-padding no-bottom-padding' },
	                _react2.default.createElement(
	                    _reactTransitionGroup.TransitionGroup,
	                    null,
	                    _react2.default.createElement(
	                        _reactTransitionGroup.Transition,
	                        { key: this.state.currentPage,
	                            timeout: 300,
	                            onEnter: function onEnter(node) {
	                                return _this3.handleCardEnter(node);
	                            },
	                            onExit: function onExit(node) {
	                                return _this3.handleCardExit(node);
	                            } },
	                        _react2.default.createElement(
	                            _Row2.default,
	                            { ref: function ref(el) {
	                                    return _this3.row = el;
	                                }, className: 'no-padding' },
	                            pagedPress.map(function (post, index) {
	                                return _react2.default.createElement(
	                                    'div',
	                                    { className: 'author-post', key: index },
	                                    _react2.default.createElement(_ArchiveContent2.default, { data: post.node, archiveType: 'press' })
	                                );
	                            })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _Row2.default,
	                { className: 'capper', style: { paddingBottom: '80px', paddingTop: '0px' } },
	                pages.length > 1 && _react2.default.createElement(_Pagination2.default, { pages: pages, currentPage: currentPage, handlePageChange: function handlePageChange(page) {
	                        return _this3.handlePageChange(page);
	                    } })
	            ),
	            _react2.default.createElement(_Apply2.default, {
	                title: 'Curious about Global Citizen Year? This is a great place to start.',
	                buttonUrl: '/academy/apply/'
	            })
	        );
	    };
	
	    return press;
	}(_react.Component);
	
	exports.default = press;
	var pressQuery = exports.pressQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-press-js-6d87ade8b1350471f351.js